import { render, staticRenderFns } from "./AdmissionTicketTypeList.vue?vue&type=template&id=195318ec&scoped=true&"
import script from "./AdmissionTicketTypeList.vue?vue&type=script&lang=js&"
export * from "./AdmissionTicketTypeList.vue?vue&type=script&lang=js&"
import style0 from "./AdmissionTicketTypeList.vue?vue&type=style&index=0&id=195318ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195318ec",
  null
  
)

export default component.exports